/**
 * Determines the number of days between two dates passed in
 * @param {Date} startDate - The starting date
 * @param {Date} endDate - The ending date
 * @returns {number} The number of days between the two dates
 */
export const calcDaysBetweenDates = (startDate, endDate) => {
	const [minDate, maxDate] = _prepareDates(startDate, endDate);

	return Math.ceil((maxDate.getTime() - minDate.getTime()) / (1000 * 60 * 60 * 24));
};

/**
 * Determines the number of trading days between two trading dates passed in
 * @param {Date} startDate - The starting trading date
 * @param {Date} endDate - The ending trading date
 * @param {string[]} tradingDays - An array of trading dates represented by strings
 * @returns {number} The number of trading days between the two trading dates
 */
export const calcTradingDaysBetweenTradingDates = (startDate, endDate, tradingDays) => {
	let [minDate, maxDate] = _prepareDates(startDate, endDate);

	// Remove time zone offset for comparison to trading days
	minDate = new Date(minDate.getTime() - minDate.getTimezoneOffset() * 60 * 1000);
	maxDate = new Date(maxDate.getTime() - maxDate.getTimezoneOffset() * 60 * 1000);

	// Get indices in tradingDays to calculate the correct number of trading days between dates passed in
	const minIndex = tradingDays.findIndex(d => new Date(d).getTime() === minDate.getTime());
	const maxIndex = tradingDays.findIndex(d => new Date(d).getTime() === maxDate.getTime());

	return maxIndex - minIndex;
};

/**
 * Prepares dates for comparison by finding min and max, and setting to midnight.
 * @param {Date} startDate - The starting date
 * @param {Date} endDate - The ending date
 * @returns {Date[]} The prepared dates
 */
const _prepareDates = (startDate, endDate) => {
	let minDate;
	let maxDate;

	// Find the min, max dates
	if (endDate.getTime() >= startDate.getTime()) {
		maxDate = endDate;
		minDate = startDate;
	} else {
		minDate = endDate;
		maxDate = startDate;
	}

	// Set dates to midnight
	minDate.setHours(0, 0, 0, 0);
	maxDate.setHours(0, 0, 0, 0);

	return [minDate, maxDate];
};

export default {
	calcDaysBetweenDates,
	calcTradingDaysBetweenTradingDates
};
